import { removeDuplicates } from '../utils/messenger_utils';


export const conversationReducer = (state, action) => {
  switch (action.type) {
    case ADD_MESSAGE_TO_CONVERSATION_THREAD_ASYNC: {
      const newMessage = {
        name: action.creator.givenName,
        body: action.thread.message.body,
        dateTime: action.thread.message.dateTime,
        avatarUrl: action.creator.headshotUrl,
        id: action.thread.message.id
      };
      const copyThread = state.thread;
      copyThread.pop();
      const updatedThread = copyThread.concat(newMessage);
      return { ...state, thread: updatedThread };
    }

    case ADD_MESSAGE_TO_CONVERSATION_THREAD_SYNC: {
      const updatedThread = state.thread.concat(action.message);
      action.handleRead();
      return { ...state, thread: updatedThread, unreadMessageCount: 0 };
    }

    case UPDATE_OPEN_CONVERSATION_FROM_LIST: {
      return { ...action.conversation };
    }
  }
  return defaultConversationState;
};

const defaultConversationState = {
  avatars: [],
  id: '',
  mostRecentMessage: '',
  orderedNames: [],
  participants: [],
  thread: [],
  unreadMessageCount: 0,
};

export const conversationListReducer = (state, action) => {
  switch (action.type) {
    case FETCH_CONVERSATION_LIST: {
      return action.conversations;
    }

    case UPDATE_CONVERSATION_LIST: {
      const updatedList = state.map((prevConvo) => {
        if (prevConvo.id === action.conversationState.id) {
          const idxLastMessage = action.conversationState.thread.length - 1;
          const mostRecentMessage =
            action.conversationState.thread[idxLastMessage].body;
          const day = action.conversationState.thread[idxLastMessage].dateTime;

          return { ...action.conversationState, mostRecentMessage, day };
        } else {
          return prevConvo;
        }
      });
      return updatedList.sort((a, b) => new Date(b.day) - new Date(a.day));
    }

    case MARK_CONVERSATION_AS_READ: {
      const updatedList = state.map((prevConvo) => {
        if (prevConvo.id === action.conversationState.id) {
          return { ...action.conversationState, unreadMessageCount: 0 };
        } else {
          return prevConvo;
        }
      });
      return updatedList;
    }

    case UPDATE_CONVERSATION_LIST_ASYNC: {
      const updatedConvos = [];
      const convos = [];

      state.forEach((convo) => {
        if (convo.id in action.latestMessages) {
          const newMessages = action.latestMessages[convo.id];
          const updatedThread = [...convo.thread, ...newMessages];
          const orderedNames = [...updatedThread]
            .reverse()
            .map(message => message.displayName)
            .filter((displayName) => convo.orderedNames.includes(displayName));

          const mergeNamesWithAndWithoutMessages = Array.from(new Set([...orderedNames, ...convo.orderedNames]));
          const mostRecentMessage = newMessages[newMessages.length - 1]
          const updatedConvo = {
            ...convo,
            orderedNames: mergeNamesWithAndWithoutMessages,
            thread: updatedThread,
            unreadMessageCount: convo.unreadMessageCount + newMessages.length,
            day: mostRecentMessage.dateTime,
            mostRecentMessage: mostRecentMessage.body,
          };
          updatedConvos.push(updatedConvo);
        } else {
          convos.push(convo);
        }
      });

      const newAndUpdatedConvos = [
        ...action.newConversations,
        ...updatedConvos,
        ...convos,
      ];

      const duplicatesRemovedFromConvos = removeDuplicates(newAndUpdatedConvos)

      action.setTotalUnreadCount(
        duplicatesRemovedFromConvos.reduce(
          (acc, val) => acc + val.unreadMessageCount,
          0
        )
      );

      return duplicatesRemovedFromConvos;
    }

    case ADD_CONVERSATION_TO_LIST_ASYNC: {
      const filteredConvos = state.filter(
        (convo) => convo.id != action.conversation.id
      );

      return [action.conversation, ...filteredConvos];
    }
  }

  return [];
};

export const defaultConvoWindowState = {
  windows: [],
};

export const convoWindowReducer = (state, action) => {
  switch (action.type) {
    case OPEN_RUNNING_CONVERSATION_WINDOW: {
      if (state.windows.some((window) => window.id === action.convo.id)) {
        return state;
      }
      return makeWindows(action.convo, state.windows);
    }

    case OPEN_NEW_CONVERSATION_WINDOW: {
      const id = Math.random().toString();
      return makeWindows({ id, type: NEW_MESSAGE }, state.windows);
    }

    case CLOSE_CONVERSATION_WINDOW: {
      const updatedWindows = state.windows.filter(
        (window) => window.id !== action.id
      );

      return {
        windows: updatedWindows,
      };
    }

    case UPDATE_RUNNING_CONVERSATION_WINDOWS: {
      const convoMap = {};
      action.conversations.forEach((convo) => (convoMap[convo.id] = convo));
      const updatedWindows = state.windows.map((window) => {
        if (window.id in convoMap) {
          return convoMap[window.id];
        } else {
          return window;
        }
      });

      return {
        windows: updatedWindows,
      };
    }
  }

  return defaultConvoWindowState;
};

function makeWindows(newConvoObj, stateWindows) {
  const updatedWindows =
    stateWindows.length >= 3
      ? [...stateWindows, newConvoObj].slice(1, 4)
      : [...stateWindows, newConvoObj];

  return {
    windows: updatedWindows,
  };
}

export const ADD_MESSAGE_TO_CONVERSATION_THREAD_ASYNC =
  'ADD_MESSAGE_TO_CONVERSATION_THREAD_ASYNC';
export const ADD_MESSAGE_TO_CONVERSATION_THREAD_SYNC =
  'ADD_MESSAGE_TO_CONVERSATION_THREAD_SYNC';
export const UPDATE_OPEN_CONVERSATION_FROM_LIST =
  'UPDATE_OPEN_CONVERSATION_FROM_LIST';
export const MARK_CONVERSATION_AS_READ = 'MARK_CONVERSATION_AS_READ';

export const FETCH_CONVERSATION_LIST = 'FETCH_CONVERSATION_LIST';
export const UPDATE_CONVERSATION_LIST = 'UPDATE_CONVERSATION_LIST';

export const UPDATE_CONVERSATION_LIST_ASYNC = 'UPDATE_CONVERSATION_LIST_ASYNC';
export const ADD_CONVERSATION_TO_LIST_ASYNC = 'ADD_CONVERSATION_TO_LIST_ASYNC';

export const OPEN_RUNNING_CONVERSATION_WINDOW =
  'OPEN_RUNNING_CONVERSATION_WINDOW';
export const OPEN_NEW_CONVERSATION_WINDOW = 'OPEN_NEW_CONVERSATION_WINDOW';
export const CLOSE_CONVERSATION_WINDOW = 'CLOSE_CONVERSATION_WINDOW';
export const UPDATE_RUNNING_CONVERSATION_WINDOWS =
  'UPDATE_RUNNING_CONVERSATION_WINDOWS';
export const NEW_MESSAGE = 'NEW MESSAGE';
